import commonMixin from './_common';
import flashMessageMixin from './_flash_messages';

/**
 * canva用テンプレートリストを取り扱うためのmixin
 */
export default {
    data() {
        return {
            // サーバから受信したテンプレートリスト
            templates: [],
            // 現在のページ
            page: 1,
            // テンプレート数が最大か否か
            is_max_count: false,
            // 「キーワードで探す」入力値
            input_keyword: '',
            // 「カテゴリ」選択値
            selected_category: 'すべて',
            // 「並び順」選択値
            selected_order: 'recommend',
            // 「サイズ」選択値
            selected_size: null,
            // 「デザイン」選択値
            selected_design: ''
        };
    },
    mixins: [
        commonMixin,
        flashMessageMixin
    ],
    computed: {
        // カテゴリ一覧
        categories: function() {
            return this.config.canva_info.categories;
        },
        // サイズ一覧
        sizes: function() {
            return this.config.canva_info.sizes;
        },
        // 表示用テンプレートリスト
        disp_banner_templates: function() {
            let resultTemplates = this.templates;
            // デザインによる絞り込み
            if (this.selected_design) {
                resultTemplates = this.filterTemplatesByDesign(resultTemplates);
            }
            // サイズによる絞り込み
            if (this.selected_size) {
                resultTemplates = this.filterTemplatesBySize(resultTemplates);
            }
            return resultTemplates;
        },
        // もっと見るのボタンの表示判定
        is_more: function () {
            return this.templates.length > 0 &&
                this.selected_category == 'すべて' &&
                this.input_keyword == '' &&
                !this.selected_design &&
                !this.is_max_count;
        }
    },
    watch: {
        selected_category(newCategory/*, oldCategory */) {
            if (newCategory == 'すべて') {
                this.page = 1;
                this.is_max_count = false;
            }
            this.getTemplateList();
        },
        selected_order() {
            this.getTemplateList();
        },
        // 1件でも表示されるように監視
        disp_banner_templates(newValue) {
            //絞り込んだ際に表示バナーが0件なら追加読込
            if (this.is_more && newValue.length === 0) {
                this.clickMore();
            }
        }
    },
    methods: {
        // テンプレートリストを取得する
        getTemplateList: async function() {
            this.$_loading();
            this.resetSelectDesign();

            let successFlg = false;
            try {
                const response = await axios.get(
                    '/canva_templates/get_templates',
                    {
                        params: {
                            end_point: 'canva2',
                            page: this.page,
                            keyword: this.input_keyword,
                            category: this.selected_category,
                            order: this.selected_order,
                        }
                    }
                );
                if (response.data.status == 'OK') {
                    if (
                        this.page >= 2 &&
                        this.selected_category == 'すべて' &&
                        this.input_keyword == ''
                    ) {
                        this.templates = this.templates.concat(response.data.data);
                        this.is_max_count = this.templates.length == response.data.count;
                    } else {
                        this.templates = response.data.data;
                    }
                    successFlg = true;
                }
            } catch (e) {
                this.appendFlashMessage(
                    {
                        level: 'alert-danger',
                        message: this.getCatchMessage(e)
                    },
                    this.$parent
                );
            } finally {
                this.$_unloading();
            }
            return successFlg;
        },
        // 「もっと見る」を押したときの処理
        clickMore: async function() {
            this.page++;

            await this.getTemplateList();
        },
        /**
         * デザインIDによる絞り込み
         */
        filterTemplatesByDesign: function(resultTemplates) {
            return resultTemplates.filter(template => {
                return template.id === this.selected_design;
            }, this);
        },
        // 選択中のデザインID解除
        resetSelectDesign: function() {
            this.selected_design = '';
            this.is_design_group = true;
        },
        /**
         * サイズによる絞り込み
         */
        filterTemplatesBySize: function(resultTemplates) {
            return resultTemplates.filter(template => {
                return template.sizes.includes(this.selected_size);
            }, this);
        },
        // サイズ選択
        selectSize: function(size) {
            // 選択中サイズと一致するなら解除
            this.selected_size = (this.selected_size === size) ? null : size;
        },
        // 選択中サイズ判定
        isCheckedSize(value) {
            return this.selected_size === value;
        }
    }
};